"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var fields_path_service_1 = require("../../service/fields-path/fields-path-service");
var path_converters_1 = require("../field-picker/path-converters");
var field_picker_dialog_component_1 = require("./field-picker-dialog/field-picker-dialog.component");
var DynamicFieldInputComponent = /** @class */ (function () {
    function DynamicFieldInputComponent(dialog, renderer, fieldsPathService) {
        this.dialog = dialog;
        this.renderer = renderer;
        this.fieldsPathService = fieldsPathService;
        this.dynamicFieldStartDelimiter = '';
        this.dynamicFieldEndDelimiter = '';
        /**
         * Emits string value with dynamic field systemNames with enclosed delimiters
         */
        this.valueChange = new core_1.EventEmitter();
        /**
         * Emits string value with display names instead of dynamic fields with delimiters
         */
        this.displayValueChange = new core_1.EventEmitter();
        this.dynamicFieldClassName = 'dfp-input__chip';
        this.destroy$ = new Subject_1.Subject();
    }
    DynamicFieldInputComponent_1 = DynamicFieldInputComponent;
    DynamicFieldInputComponent.escapeRegExp = function (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    };
    DynamicFieldInputComponent.prototype.ngOnChanges = function (changes) {
        if (changes['value'] && !changes['value'].isFirstChange() && this.value !== this.lastEmittedValue) {
            this.parseValueToHtml();
        }
    };
    DynamicFieldInputComponent.prototype.ngOnInit = function () {
        if (this.dynamicFieldStartDelimiter && this.dynamicFieldEndDelimiter) {
            var escapedStartDelimiter = DynamicFieldInputComponent_1.escapeRegExp(this.dynamicFieldStartDelimiter);
            var escapedEndDelimiter = DynamicFieldInputComponent_1.escapeRegExp(this.dynamicFieldEndDelimiter);
            // RegEx to find expressions enclosed in delimiters
            this.dynamicFieldRegEx = new RegExp(escapedStartDelimiter + '(.*?)' + escapedEndDelimiter, 'mg');
        }
    };
    DynamicFieldInputComponent.prototype.ngAfterViewInit = function () {
        this.parseValueToHtml();
    };
    DynamicFieldInputComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    DynamicFieldInputComponent.prototype.onInputChange = function () {
        this.lastEmittedValue = this.getCurrentValue();
        this.valueChange.emit(this.lastEmittedValue);
        this.displayValueChange.emit(this.getCurrentDisplayValue());
    };
    DynamicFieldInputComponent.prototype.onKeyDown = function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    /**
     * Handle paste event, if data type is not text, converts to text, clears spaces and enters and insert in the place of cursor.
     * @param event
     */
    DynamicFieldInputComponent.prototype.onPaste = function (event) {
        var clipboardData = event.clipboardData;
        var hasClipboardDataTypes = clipboardData && clipboardData.types && clipboardData.types.length;
        var hasTextPlain = hasClipboardDataTypes && clipboardData.types.some(function (type) { return type !== 'text/plain'; });
        if (hasTextPlain) {
            event.preventDefault();
            var clipboardValue = clipboardData.getData('text/plain') || '';
            if (clipboardValue) {
                this.insertTextAtCaret(clipboardValue.replace(/\r?\n|\r/g, ' ').trim());
                this.onInputChange();
            }
        }
    };
    DynamicFieldInputComponent.prototype.openFieldPickerDialog = function () {
        var _this = this;
        this.saveSelection();
        var dialogRef = this.dialog.open(field_picker_dialog_component_1.FieldPickerDialogComponent, {
            width: '520px',
            data: {
                entitySystemNames: this.entitySystemNames
            }
        });
        dialogRef.afterClosed()
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (data) {
            _this.restoreSelection();
            if (data) {
                _this.insertDynamicFieldAtCaret(data);
                _this.onInputChange();
            }
        });
    };
    DynamicFieldInputComponent.prototype.onFieldInputClick = function (event) {
        var _this = this;
        if (event.target.className === this.dynamicFieldClassName) {
            var value = event.target.getAttribute('data-path');
            if (value) {
                this.saveSelection();
                var dialogRef = this.dialog.open(field_picker_dialog_component_1.FieldPickerDialogComponent, {
                    width: '720px',
                    data: {
                        path: value,
                        entitySystemNames: this.entitySystemNames
                    }
                });
                dialogRef.afterClosed()
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe(function (data) {
                    _this.restoreSelection();
                    if (data) {
                        event.target.innerText = data.displayName;
                        event.target.setAttribute('data-path', data.path);
                        _this.onInputChange();
                    }
                });
            }
        }
    };
    /**
     * Creates and Inserts dynamic field html in the place of last cursor selection or prepends it to our fieldInput
     * @private
     * @param data
     */
    DynamicFieldInputComponent.prototype.insertDynamicFieldAtCaret = function (data) {
        var sel, range;
        // focus to our fieldInput to insert elements to our container, because last selection could be in the other parts of html
        this.fieldInput.nativeElement.focus();
        var dynamicFieldElement = document.createElement('span');
        this.renderer.setProperty(dynamicFieldElement, 'className', this.dynamicFieldClassName);
        this.renderer.setProperty(dynamicFieldElement, 'contentEditable', false);
        this.renderer.setAttribute(dynamicFieldElement, 'data-path', data.path);
        dynamicFieldElement.innerText = data.displayName;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                range.insertNode(dynamicFieldElement);
                // Preserve the selection
                if (dynamicFieldElement) {
                    range = range.cloneRange();
                    range.setStartAfter(dynamicFieldElement);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
        else {
            this.fieldInput.nativeElement.append(dynamicFieldElement);
        }
        this.fieldInput.nativeElement.focus();
    };
    DynamicFieldInputComponent.prototype.insertTextAtCaret = function (data) {
        var sel, range;
        // focus to our fieldInput to insert elements to our container, because last selection could be in the other parts of html
        this.fieldInput.nativeElement.focus();
        var textNode = document.createTextNode(data);
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                console.log(range.endContainer);
                range.deleteContents();
                range.insertNode(textNode);
                // Preserve the selection
                if (data && textNode) {
                    range = range.cloneRange();
                    range.setStartAfter(textNode);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
        else {
            this.fieldInput.nativeElement.append(textNode);
        }
        this.fieldInput.nativeElement.focus();
    };
    /**
     * Before dialog opens, save cursor selection for future data insertion in a proper place
     */
    DynamicFieldInputComponent.prototype.saveSelection = function () {
        var d = document;
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                this.selectionCache = sel.getRangeAt(0);
                !sel.containsNode(this.fieldInput.nativeElement, true) && (this.selectionCache = null);
                return;
            }
        }
        else if (d.selection && d.selection.createRange) {
            this.selectionCache = d.selection.createRange();
            return;
        }
        this.selectionCache = null;
    };
    /**
     * Restore cursor selection for data insertion in input
     */
    DynamicFieldInputComponent.prototype.restoreSelection = function () {
        if (this.selectionCache) {
            if (window.getSelection) {
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.selectionCache);
            }
        }
        else {
            // if user didn't place cursor anywhere, create range with fieldInput and set cursor to end
            if (window.getSelection) {
                var sel = window.getSelection();
                var range = document.createRange();
                sel.removeAllRanges();
                // select end of input before last <br> element if it exists or just end of input
                this.fieldInput.nativeElement.lastChild ? range.setStartBefore(this.fieldInput.nativeElement.lastChild) : range.selectNodeContents(this.fieldInput.nativeElement);
                range.collapse(false);
                sel.addRange(range);
            }
        }
    };
    /**
     * Converts string value to html, replaces enclosing dollar signs ($) with html span tag with specific class
     * @private
     */
    DynamicFieldInputComponent.prototype.parseValueToHtml = function () {
        var _this = this;
        if (this.value) {
            var dynamicFieldMatches = this.value.match(this.dynamicFieldRegEx);
            var paths_1 = dynamicFieldMatches && dynamicFieldMatches.map(function (value) {
                return value.replace(_this.dynamicFieldStartDelimiter, '').replace(_this.dynamicFieldEndDelimiter, '');
            });
            if (paths_1 && paths_1.length) {
                var pathFields = paths_1.map(function (value) { return path_converters_1.convertFieldPathToFieldViews(value.split(':')[1], _this.fieldsPathService); });
                zip_1.zip.apply(void 0, pathFields).pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe(function (data) {
                    var parsedValue = _this.value;
                    paths_1.forEach(function (path, index) {
                        var displayName = path_converters_1.convertFieldViewsToFieldPathDisplayName(data[index]);
                        parsedValue = parsedValue.replace("" + _this.dynamicFieldStartDelimiter + path + _this.dynamicFieldEndDelimiter, "<span class=\"" + _this.dynamicFieldClassName + "\" data-path=\"" + path + "\" contentEditable=\"false\">" + displayName + "</span>");
                    });
                    _this.renderer.setProperty(_this.fieldInput.nativeElement, 'innerHTML', parsedValue + '<br>'); // br added for right position of caret
                });
            }
            else {
                this.renderer.setProperty(this.fieldInput.nativeElement, 'innerHTML', this.value + '<br>');
            }
        }
        else {
            this.renderer.setProperty(this.fieldInput.nativeElement, 'innerHTML', '<br>');
        }
    };
    DynamicFieldInputComponent.prototype.getCurrentValue = function () {
        var _this = this;
        if (this.fieldInput) {
            var dynamicInputDummyElement = document.createElement('div');
            this.renderer.setProperty(dynamicInputDummyElement, 'innerHTML', this.fieldInput.nativeElement.innerHTML);
            var elements = dynamicInputDummyElement.querySelectorAll('span[data-path]');
            if (elements && elements.length) {
                Array.from(elements).forEach(function (element) {
                    element.innerText = "" + _this.dynamicFieldStartDelimiter + element.getAttribute('data-path') + _this.dynamicFieldEndDelimiter;
                });
            }
            return dynamicInputDummyElement.innerText.trim();
        }
        return '';
    };
    DynamicFieldInputComponent.prototype.getCurrentDisplayValue = function () {
        return this.fieldInput ? this.fieldInput.nativeElement.innerText.trim() : '';
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicFieldInputComponent.prototype, "entitySystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicFieldInputComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicFieldInputComponent.prototype, "dynamicFieldStartDelimiter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicFieldInputComponent.prototype, "dynamicFieldEndDelimiter", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DynamicFieldInputComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DynamicFieldInputComponent.prototype, "displayValueChange", void 0);
    __decorate([
        core_1.ViewChild('fieldInput'),
        __metadata("design:type", core_1.ElementRef)
    ], DynamicFieldInputComponent.prototype, "fieldInput", void 0);
    DynamicFieldInputComponent = DynamicFieldInputComponent_1 = __decorate([
        core_1.Component({
            selector: 'sis-dynamic-field-input',
            template: require('./dynamic-field-input.component.html'),
            styles: [require('./dynamic-field-input.component.css')]
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            core_1.Renderer2,
            fields_path_service_1.FieldsPathService])
    ], DynamicFieldInputComponent);
    return DynamicFieldInputComponent;
    var DynamicFieldInputComponent_1;
}());
exports.DynamicFieldInputComponent = DynamicFieldInputComponent;
//# sourceMappingURL=dynamic-field-input.component.js.map